import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { WorkflowItemDirective } from '@workflow/directives/workflow-item/workflow-item.directive';
import { Subscription } from 'rxjs';
import { UnsubscribeOnDestroy } from '@app/util/lifecycle-hooks/lifecycle-hooks';
import { IQuestionnaireWorkflowItem, IWorkflowItem } from '@interfaces/interfaces';
import { flatten } from 'lodash';
import { BlockQuestion, BlockQuestionItem } from '@interfaces/questions';

function isQuestionnaire(item: IWorkflowItem | undefined): item is IQuestionnaireWorkflowItem {
	return item?.type === 'Questionnaire';
}

@Pipe({
	name: 'questionLabel',
	pure: false,
})
export class QuestionLabelPipe implements PipeTransform {
	@UnsubscribeOnDestroy
	private readonly subscription = new Subscription();
	private questions: BlockQuestion[] = [];
	
	constructor(workflowItem: WorkflowItemDirective, cdr: ChangeDetectorRef) {
		this.subscription.add(
			workflowItem.workflowItem$.subscribe(item => {
				if (isQuestionnaire(item)) {
					const blockQuestions = flatten(
						item.groups.map(g => g.items),
					).filter((qItem): qItem is BlockQuestionItem => qItem.type === 'BlockQuestion');
					
					this.questions = flatten(blockQuestions.map(qItem => qItem.items));
				} else {
					this.questions = [];
				}
				
				cdr.markForCheck();
			}),
		);
	}
	
	public transform<D>(key: string, defaultValue: D): string | D;
	public transform(key: string): string | undefined;
	public transform<D = undefined>(key: string, defaultValue?: D): string | D {
		return this.questions.find(question => question.key === key)?.queryLabel ?? defaultValue;
	}
}
